<div [innerHTML]="template" [ngClass]="{'major-div':websiteName=='Major'}"></div>